import React, { useCallback, useEffect, useState } from 'react';

import { Table, Layout } from '../../../components';
import { RoutesPaths } from '../../../routes';
import api from '../../../services/api';
import type { ScreenData } from '../../../shared/interfaces/screen';

const Lista: React.FC = () => {
  const [dataScreen, setDataScreen] = useState<ScreenData[]>([]);

  const fetchData = useCallback(async () => {
    try {
      const { data } = await api.get<ScreenData[]>('/tela');

      setDataScreen(data);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Layout
      title={'Lista de Telas'}
      buttonRedirect={RoutesPaths.registerScreen}
      buttonTitle={'Nova Tela'}
      hideFloatingButton
    >
      <Table
        headingColumns={['Título', 'Ícone', 'Subtitulo', 'URL', 'Ações']}
        tableData={dataScreen}
        disableDelete
        editPagePath={RoutesPaths.editScreen}
        messageModal={'Confirma a exclusão da Tela?'}
        titleModal={'Excluir Tela'}
        descriptionToast={'A Tela foi removida.'}
        titleToast={'Tela excluída com sucesso!'}
      />
    </Layout>
  );
};

export default Lista;
